import { Dictionary, isEmpty, isNil, omitBy } from "lodash";

export const purge = <T>(
  object: Dictionary<T> | null | undefined
): Dictionary<T> => omitBy(omitBy(object, isNil), isEmpty);
